import { Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = ({ openServiceModal, openPlatformModal }) => {
  // Service IDs match the ones in Services.jsx
  const serviceLinks = [
    { id: 'bug-fixes', label: 'Bug Fixing' },
    { id: 'security-updates', label: 'Security Hardening' },
    { id: 'performance-optimization', label: 'Performance Optimization' },
    { id: 'feature-implementation', label: 'Feature Implementation' },
    { id: 'website-updates', label: 'Website Updates' }
  ];

  // Platform IDs match the ones in Platforms.jsx
  const platformLinks = [
    { id: 1, label: 'WordPress' },
    { id: 2, label: 'Shopify' },
    { id: 3, label: 'Webflow' },
    { id: 4, label: 'Wix' },
    { id: 5, label: 'Squarespace' }
  ];

  // Function to handle service click with direct openServiceModal access
  const handleServiceClick = (serviceId) => {
    if (typeof openServiceModal === 'function') {
      openServiceModal(serviceId);
    } else {
      console.warn(`Modal function not available for service: ${serviceId}`);
    }
  };

  // Function to handle platform click with direct openPlatformModal access
  const handlePlatformClick = (platformId) => {
    if (typeof openPlatformModal === 'function') {
      openPlatformModal(platformId);
    } else {
      console.warn(`Modal function not available for platform: ${platformId}`);
    }
  };

  return (
    <footer className="bg-gray-900 text-white" id="contact">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold mb-6">Gravity Point Media</h3>
            <p className="text-gray-400 mb-6">
              Professional website support and maintenance services to keep your site running smoothly.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/gravitypointmedia" className="text-gray-400 hover:text-white transition-colors" target="_blank" rel="noopener noreferrer">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/gravitypointmedia" className="text-gray-400 hover:text-white transition-colors" target="_blank" rel="noopener noreferrer">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((service) => (
                <li key={service.id}>
                  <button 
                    onClick={() => handleServiceClick(service.id)}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    {service.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Platforms</h4>
            <ul className="space-y-3">
              {platformLinks.map((platform) => (
                <li key={platform.id}>
                  <button 
                    onClick={() => handlePlatformClick(platform.id)}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    {platform.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Mail className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                <span>support@gravitypointmedia.com</span>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                <span>155 Willowbrook Blvd. Ste 110,
                Wayne, New Jersey 07470</span>
              </li>
            </ul>
            <div className="mt-6">
              <a
                href="/register"
                className="inline-flex items-center justify-center px-5 py-2.5 bg-primary text-white font-medium rounded-md hover:bg-primary/90 transition-colors"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          <div className="mb-4 flex justify-center space-x-6">
            <a href="/terms" className="hover:text-white transition-colors">Terms & Conditions</a>
            <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
          </div>
          <p>© {new Date().getFullYear()} Gravity Point Media. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;